import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import TrustedBy from './components/TrustedBy'
import About from './components/About'
import Values from './components/Values'
import Services from './components/Services'
import Jobs from './components/Jobs'
import Process from './components/Process'
import CTA from './components/CTA'
import Contact from './components/Contact'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'
import ScrollProgress from './components/ScrollProgress'
import Admin from './pages/Admin'
import NotFound from './pages/NotFound'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app">
        <Routes>
          <Route path="/admin" element={
            <ErrorBoundary>
              <Admin />
            </ErrorBoundary>
          } />
          <Route path="/" element={
            <>
              <ScrollProgress />
              <Navbar />
              <main>
                <Hero />
                <TrustedBy />
                <About />
                <Values />
                <Services />
                <Process />
                <ErrorBoundary>
                  <Jobs />
                </ErrorBoundary>
                <CTA />
                <Contact />
              </main>
              <Footer />
              <BackToTop />
            </>
          } />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
